'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { callIfPossible } from '../core/Functions';
import { getDefaultNode } from '../utils/RootNode';
import domElementPropType from '../utils/propTypes/domElement';
import PortalLayer from './internal/PortalLayer';
import { jsx as _jsx } from "react/jsx-runtime";
class UILayer extends Component {
  constructor(props) {
    super(props);
    this.handleCloseComplete = () => {
      const {
        onCloseComplete,
        transitionProps
      } = this.props;
      callIfPossible(transitionProps && transitionProps.onCloseComplete);
      callIfPossible(onCloseComplete);
      if (this._element.parentNode) {
        this._element.parentNode.removeChild(this._element);
      }
    };
    this.renderTree = content => {
      const {
        Transition,
        transitionProps
      } = this.props;
      if (!Transition) return content;
      return /*#__PURE__*/_jsx(Transition, Object.assign({}, transitionProps, {
        onCloseComplete: this.handleCloseComplete,
        transitionOnMount: transitionProps && transitionProps.transitionOnMount,
        children: content
      }));
    };
    this._rootNode = props.rootNode || getDefaultNode();
    this._element = document.createElement('div');
    this._element.className = 'private-layer';
    this._element.setAttribute('data-layer-for', props['data-layer-for']);
    this._element.setAttribute('data-test-id', props['data-test-id']);
    this._rootNode.appendChild(this._element);
  }

  // Under createRoot + Suspense, the constructor runs once but the component
  // can unmount and remount without a new instance. Re-attach the DOM element
  // if componentWillUnmount removed it during a suspend/resume cycle.
  componentDidMount() {
    if (!this._element.parentNode) {
      this._rootNode.appendChild(this._element);
    }
  }
  componentWillUnmount() {
    const {
      Transition
    } = this.props;
    if (!Transition) this.handleCloseComplete();
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx(PortalLayer, {
      element: this._element,
      renderTree: this.renderTree,
      children: children
    });
  }
}
UILayer.displayName = 'UILayer';
UILayer.propTypes = {
  children: PropTypes.node.isRequired,
  'data-layer-for': PropTypes.string,
  'data-test-id': PropTypes.string,
  onCloseComplete: PropTypes.func,
  rootNode: domElementPropType,
  Transition: PropTypes.elementType,
  transitionProps: PropTypes.object
};
export default UILayer;